import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class MachineBrigadeApi extends ApiModule {
	constructor() {
		super(ModulesMap.MACHINE_BRIGADE, {
			entity: 'brigade',
			parentEntity: 'machines',
		})
	}
}
